import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import { fetchTable } from "../../api";

function MomentumVsVolChart() {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    fetchTable("intraday_momentum_vs_volatility", "n50")
      .then((data) => {
        if (data.data) setChartData(data.data);
      })
      .catch((err) => console.error("Error fetching data:", err));
  }, []);

  if (!chartData.length) return <p>Loading chart...</p>;

  const momentum = chartData.map((d) => d.momentum);
  const volatility = chartData.map((d) => d.volatility);

  // Dynamic thresholds
  const mMedian = momentum.sort((a, b) => a - b)[Math.floor(momentum.length / 2)];
  const vMedian = volatility.sort((a, b) => a - b)[Math.floor(volatility.length / 2)];

  // Quadrant classification with dynamic thresholds
  const classify = (m, v) => {
    if (m >= mMedian && v >= vMedian) return "Q1: Speculative Winners";
    if (m >= mMedian && v < vMedian) return "Q2: Stable Winners";
    if (m < mMedian && v < vMedian) return "Q3: Stable Losers";
    return "Q4: Speculative Losers";
  };

  const traces = {
    "Q1: Speculative Winners": { x: [], y: [], text: [], color: "red" },
    "Q2: Stable Winners": { x: [], y: [], text: [], color: "green" },
    "Q3: Stable Losers": { x: [], y: [], text: [], color: "gray" },
    "Q4: Speculative Losers": { x: [], y: [], text: [], color: "blue" },
  };

  chartData.forEach((d) => {
    const q = classify(d.momentum, d.volatility);
    traces[q].x.push(d.momentum);
    traces[q].y.push(d.volatility);
    traces[q].text.push(d.symbol);
  });

  return (
    <Plot
      data={Object.entries(traces).map(([q, grp]) => ({
        x: grp.x,
        y: grp.y,
        text: grp.text,
        mode: "markers+text",
        textposition: "top center",
        marker: { size: 10, color: grp.color, opacity: 0.7 },
        name: q,
      }))}
      layout={{
        title: "Intraday Momentum vs Volatility (1H)",
        xaxis: { title: "Momentum (%)", zeroline: true },
        yaxis: { title: "Volatility (%)", zeroline: true },
        plot_bgcolor: "white",
        height: 650,
        width: 850,
        shapes: [
          // Vertical divider @ mMedian
          {
            type: "line",
            x0: mMedian,
            y0: Math.min(...volatility),
            x1: mMedian,
            y1: Math.max(...volatility),
            line: { color: "black", dash: "dot" },
          },
          // Horizontal divider @ vMedian
          {
            type: "line",
            x0: Math.min(...momentum),
            y0: vMedian,
            x1: Math.max(...momentum),
            y1: vMedian,
            line: { color: "black", dash: "dot" },
          },
          // Quadrant backgrounds
          {
            type: "rect",
            x0: mMedian,
            y0: vMedian,
            x1: Math.max(...momentum),
            y1: Math.max(...volatility),
            fillcolor: "rgba(255,0,0,0.05)",
            line: { width: 0 },
          },
          {
            type: "rect",
            x0: mMedian,
            y0: Math.min(...volatility),
            x1: Math.max(...momentum),
            y1: vMedian,
            fillcolor: "rgba(0,255,0,0.05)",
            line: { width: 0 },
          },
          {
            type: "rect",
            x0: Math.min(...momentum),
            y0: Math.min(...volatility),
            x1: mMedian,
            y1: vMedian,
            fillcolor: "rgba(128,128,128,0.05)",
            line: { width: 0 },
          },
          {
            type: "rect",
            x0: Math.min(...momentum),
            y0: vMedian,
            x1: mMedian,
            y1: Math.max(...volatility),
            fillcolor: "rgba(0,0,255,0.05)",
            line: { width: 0 },
          },
        ],
        legend: { orientation: "h", x: 0, y: -0.2 },
      }}
      config={{ responsive: true }}
    />
  );
}

export default MomentumVsVolChart;

